import {SECONDS_IN_MINUTE} from '../../../../constants/constants';
import {
  MAX_INTERVAL_COUNT,
  MAX_INTERVAL_TIME_IN_SECONDS,
  PERCENT_RATE
} from '../../../../constants/timeProgressBar';

type IntervalsParams = {
  intervals: number[],
  activeIntervalWidth: number,
  formattedTime: string
}

const formatTime = (time: number): string => {
  const minutes = Math.floor(time / SECONDS_IN_MINUTE);
  const seconds = Math.floor(time - minutes * SECONDS_IN_MINUTE);

  if (!minutes) {
    return `${seconds}s`;
  }

  return `${minutes}m ${seconds}s`;
};

export const getIntervalsParams = (
    currentTime: number,
    max: number
): IntervalsParams => {
  const timeDiff = currentTime - max;
  const countOfIntervals = timeDiff / MAX_INTERVAL_TIME_IN_SECONDS;

  const resultCountOfIntervals =
    Math.ceil(countOfIntervals) >= MAX_INTERVAL_COUNT ?
      MAX_INTERVAL_COUNT :
      Math.ceil(countOfIntervals);

  const intervals = [...Array(resultCountOfIntervals).keys()];

  const activeIntervalWidth = countOfIntervals * PERCENT_RATE -
    ((resultCountOfIntervals - 1) * PERCENT_RATE);

  const activeIntervalTimer = activeIntervalWidth *
    (MAX_INTERVAL_TIME_IN_SECONDS / PERCENT_RATE);

  const formattedTime = formatTime(activeIntervalTimer);

  return {
    intervals,
    activeIntervalWidth,
    formattedTime
  };
};
